<template>
  <div class="warning-map-container">
    <div class="warning-map">
      <img :src="backgroundImage" alt="Map Background" class="map-background" />
      <div
        v-for="(tag, index) in filteredWarningTags"
        :key="index"
        :style="{ top: tag.y + 'px', left: tag.x + 'px' }"
        class="tag-marker"
        @click="showTagInfo(tag.tag_mac)"
      >
        {{ tag.devicename }}
      </div>

      <!-- 팝업 모달 -->
      <div v-if="selectedTagInfo" class="modal">
        <div class="modal-content">
          <span class="close" @click="selectedTagInfo = null">&times;</span>
          <h3>{{ selectedTagInfo.devicename }}</h3>
          <p><strong>MAC:</strong> {{ selectedTagInfo.tag_mac }}</p>
          <p><strong>Type:</strong> {{ selectedTagInfo.devicetype }}</p>
          <p><strong>Temperature:</strong> {{ selectedTagInfo.tag_temperature }}</p>
          <p><strong>Battery:</strong> {{ selectedTagInfo.tag_vol }}</p>
          <p><strong>RSSI:</strong> {{ selectedTagInfo.tag_rssi }}</p>
          <p><strong>Location:</strong> {{ selectedTagInfo.building }} - {{ selectedTagInfo.floor }} - {{ selectedTagInfo.taglocation }}</p>
          <p><strong>Zone:</strong> {{ selectedTagInfo.assignedzone }}</p>
          <!-- <img :src="selectedTagInfo.imagepath" alt="Device Image" v-if="selectedTagInfo.imagepath" /> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  data() {
    return {
      backgroundImage: require('@/assets/warehose 3.png'),

      warningTags: [],
      selectedTagInfo: null
    };
  },
  computed: {
    filteredWarningTags() {
      return this.warningTags.filter(tag => tag.devicename); // 필터링된 태그 목록
    }
  },
  mounted() {
    this.loadWarningTags();
  },
  methods: {
    async loadWarningTags() {
      try {
        const response = await axios.get('/api/warningMapTagList');
        console.log(response.data);

        if (Array.isArray(response.data)) {
          this.warningTags = response.data.map(tag => ({
            ...tag,
            x: Math.random() * 600, // X 좌표 예시
            y: Math.random() * 500  // Y 좌표 예시
          }));
        } else {
          console.error('Data format is not an array:', response.data);
        }
      } catch (error) {
        console.error('Failed to load warning tags:', error);
      }
    },
    async showTagInfo(tag_mac) {
      try {
        const response = await axios.get('/api/warningTagInfo', { params: { tag_mac } });
        this.selectedTagInfo = response.data;
      } catch (error) {
        console.error('Failed to load tag info:', error);
      }
    }
  }
};
</script>


<style scoped>
.warning-map-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
}

.warning-map {
  position: relative;
  width: auto;
  height: auto;
}

.map-background {
  width: 800px;
  height: auto;
}

.tag-marker {
  position: absolute;
  background-color: red;
  color: white;
  padding: 5px;
  border-radius: 5px;
  cursor: pointer;
}

.modal {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: white;
  padding: 20px;
  border: 1px solid #ccc;
  z-index: 1000;
}

.modal-content {
  position: relative;
  padding: 20px;
}

.close {
  position: absolute;
  top: 10px;
  right: 10px;
  cursor: pointer;
}
</style>
